export const cardStyles = ({ palette }) => ({
  display: 'flex',
  flexDirection: 'column',
  gap: 2,
  padding: 2,
  borderRadius: 2,
  border: `1px solid ${palette.info.main}`,
  backgroundColor: palette.background.paper,
  boxShadow: palette.shadow?.s,
});

export const headerStyles = {
  display: 'flex',
  flexDirection: 'column',
  gap: 1,
};

export const headerTitleRowStyles = ({ palette }) => ({
  display: 'flex',
  alignItems: 'center',
  gap: 1,
  justifyContent: 'space-between',
  flexWrap: 'wrap',
  paddingBottom: 1,
  borderBottom: `1px solid ${palette.divider}`,
});

export const transitionRowStyles = {
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'space-between',
  gap: 1,
  flexWrap: 'wrap',
};

export const summaryRowStyles = {
  display: 'flex',
  alignItems: 'center',
  gap: 1,
  flexWrap: 'wrap',
};

export const liveFillRowStyles = {
  display: 'flex',
  alignItems: 'center',
  gap: 0.75,
};

export const progressBlockStyles = {
  display: 'flex',
  flexDirection: 'column',
  gap: 0.75,
};

export const progressLabelRowStyles = ({ palette }) => ({
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'space-between',
  gap: 1,
  color: palette.text.secondary,
  fontVariantNumeric: 'tabular-nums',
});

export const progressStripTrackStyles = ({ palette }) => ({
  position: 'relative',
  width: '100%',
  height: 8,
  borderRadius: 999,
  overflow: 'hidden',
  backgroundColor: palette.action.hover,
});

const PERCENT_SCALE = 100;

export const getProgressStripFillStyles =
  ratio =>
  ({ palette }) => ({
    position: 'absolute',
    insetBlock: 0,
    insetInlineStart: 0,
    width: `${Math.round(Math.min(Math.max(ratio, 0), 1) * PERCENT_SCALE)}%`,
    borderRadius: 999,
    backgroundColor: palette.primary.main,
    transition: 'width 240ms ease',
  });

export const fieldMetaRowStyles = {
  display: 'flex',
  alignItems: 'center',
  gap: 1,
  flexWrap: 'wrap',
};

export const docLinkStyles = {
  cursor: 'pointer',
  textDecoration: 'underline',
};

export const tableStyles = ({ palette }) => ({
  display: 'flex',
  flexDirection: 'column',
  border: `1px solid ${palette.divider}`,
  borderRadius: 1,
  overflow: 'hidden',
});

export const tableRowStyles = ({ palette }) => ({
  display: 'flex',
  gap: 1,
  paddingX: 1,
  paddingY: 0.5,
  borderBottom: `1px solid ${palette.divider}`,
  '&:last-of-type': { borderBottom: 'none' },
});

export const tableCellStyles = {
  flex: 1,
  minWidth: 0,
};

export const DIFF_ROW_TONE = {
  MATCHED: 'matched',
  AI_ONLY: 'aiOnly',
  RECORD_ONLY: 'recordOnly',
};

const diffRowToneBackground = (palette, tone) => {
  if (tone === DIFF_ROW_TONE.AI_ONLY) {
    return palette.info.light;
  }

  if (tone === DIFF_ROW_TONE.RECORD_ONLY) {
    return palette.warning.light;
  }

  return palette.background.paper;
};

export const getDiffRowStyles =
  tone =>
  ({ palette }) => ({
    display: 'flex',
    gap: 1,
    paddingX: 1,
    paddingY: 0.5,
    borderBottom: `1px solid ${palette.divider}`,
    backgroundColor: diffRowToneBackground(palette, tone),
    '&:last-of-type': { borderBottom: 'none' },
  });

export const diffStateCellStyles = {
  flex: '0 0 200px',
  minWidth: 0,
};
